'use client';

import React from 'react';

const PlaysSkeleton = () => (
  <div className="flex flex-col gap-4" data-testid="plays-loading">
    {Array.from({ length: 2 }).map((_, i) => (
      <div
        key={i}
        className="bg-white border border-neutral-200 rounded-lg px-5 py-4 flex items-center justify-between gap-3 animate-pulse"
      >
        <div className="flex flex-col gap-2 flex-1">
          <div className="h-4 w-1/3 bg-neutral-200 rounded" />
          <div className="h-3 w-2/3 bg-neutral-100 rounded" />
        </div>
        <div className="h-3 w-3 bg-neutral-200 rounded" />
      </div>
    ))}
  </div>
);

export default PlaysSkeleton;
